import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { NbAuthService } from "@nebular/auth";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: NbAuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.isAuthenticated().pipe(
      map((isAuth: boolean) => {
        if (isAuth) {
          // Se autenticado, permitir acesso (true)
          return true;
        } else {
          // Se não autenticado, retornar UrlTree para /auth/login
          // Isso faz com que o Router redirecione automaticamente
          return this.router.parseUrl("/auth/login");
        }
      })
    );
  }
}
